import Vue from 'vue'
import Router from 'vue-router'

import Store from './store'

import SessionStorage from './helpers/sessionStorage'
import Storage from './helpers/storage'

import Auth from './modules/auth'

import AddInbox from './views/AddInbox.vue'
import ConsentPage from './views/ConsentPage.vue'
import FetchEndEmpty from './views/FetchEndEmpty.vue'
import FetchV2 from './views/FetchV2.vue'
import Landing from './views/Landing/Landing'
import LoginEmail from './views/LoginEmail.vue'
import LoginFlowGoogle from './views/LoginFlowGoogle.vue'
import LoginPage from './views/LoginPage.vue'
import LoginProvider from './views/LoginProvider.vue'
import MagicLinkPre from './views/MagicLinkPre.vue'
import MagicLinkPost from './views/MagicLinkPost.vue'
import MicrosoftLoading from './views/MicrosoftLoading.vue'
import MyActions from './views/MyActions.vue'
import NewslettersV2 from './views/NewslettersV2.vue'
import Partner from './views/Partner.vue'
import DirectDeleteAccount from './views/DirectDeleteAccount.vue'
import SaveThePlanet from './views/SaveThePlanet.vue'
import Settings from './views/Settings.vue'
import Stats from './views/Stats.vue'
import TikTokRedirect from './views/TikTokRedirect'
import UpdateApp from './views/UpdateApp.vue'
import UserForm from './views/UserForm.vue'
import WeForest from './views/WeForest.vue'

import Agreements from './modules/agreements'
import Providers from './modules/providers'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: `/${Storage.getItem('lang')}`,
    routes: [
        {
            path: '/',
            name: 'landing',
            component: Landing,
            beforeEnter: LandingRules
        },
        {
            path: '/consent-page',
            name: 'consent-page',
            component: ConsentPage
        },
        //microsoft
        {
            path: '/login/microsoft/success',
            redirect: '/connect/microsoft'
        },
        {
            path: '/login/microsoft/error',
            redirect: '/connect/microsoft'
        },
        {
            path: '/connect/microsoft',
            name: 'microsoft-loading',
            component: MicrosoftLoading
        },
        {
            path: '/login/microsoft',
            component: UpdateApp
        },
        // end microsoft
        {
            path: '/login',
            name: 'login',
            component: LoginPage,
            beforeEnter: loginRules
        },
        {
            path: '/login/email',
            name: 'login-email',
            component: LoginEmail
        },
        {
            path: '/login/google',
            name: 'login-google',
            component: LoginFlowGoogle,
            beforeEnter: loginRules
        },
        {
            path: '/login/google/app_pass',
            redirect: () => ({
                path: '/login/google',
                query: {step: 'app_pass'}
            })
        },
        {
            path: '/login/yahoo',
            component: LoginProvider,
            beforeEnter: loginRules
        },
        {
            path: '/login/outlook',
            component: LoginProvider,
            beforeEnter: loginRules
        },
        {
            path: '/login/windowslive',
            component: LoginProvider,
            beforeEnter: loginRules
        },
        {
            path: '/login/aol',
            component: LoginProvider,
            beforeEnter: loginRules
        },
        {
            path: '/login/gmx',
            component: LoginProvider,
            beforeEnter: loginRules
        },
        {
            path: '/login/icloud',
            component: LoginProvider,
            beforeEnter: loginRules
        },
        {
            path: '/login/web',
            component: LoginProvider,
            beforeEnter: loginRules
        },
        {
            path: '/login/:provider',
            redirect: '/login'
        },
        {
            path: '/magic-request-email',
            name: 'magic-request',
            component: MagicLinkPre
        },
        {
            path: '/magic-link',
            name: 'magic-link',
            component: MagicLinkPost
        },
        {
            path: '/auth-link',
            name: 'auth-link',
            component: MagicLinkPost
        },
        {
            path: '/user-form',
            name: 'user-form',
            component: UserForm,
            beforeEnter: checkRights
        },
        {
            path: '/newsletters',
            name: 'NewslettersV2',
            component: NewslettersV2,
            beforeEnter: checkRights
        },
        {
            path: '/my-actions',
            name: 'my-actions',
            component: MyActions,
            beforeEnter: checkRights
        },
        {
            path: '/fetch',
            name: 'FetchV2',
            component: FetchV2,
            beforeEnter: checkRights
        },
        {
            path: '/fetch-end-empty',
            name: 'FetchEndEmpty',
            component: FetchEndEmpty,
            beforeEnter: checkRights
        },
        {
            path: '/add-inbox',
            name: 'add-inbox',
            component: AddInbox,
            beforeEnter: checkRights
        },
        {
            path: '/settings',
            name: 'settings',
            component: Settings,
            beforeEnter: checkRights
        },
        {
            path: '/settings/:page',
            name: 'settings',
            component: Settings,
            beforeEnter: checkRights
        },
        {
            path: '/stats',
            name: 'stats',
            component: Stats,
            beforeEnter: checkRights
        },
        {
            path: '/instant-apps',
            component: TikTokRedirect
        },
        {
            path: '/weforest',
            name: 'weforest',
            component: WeForest,
            beforeEnter: checkRights
        },
        {
            path: '/direct-delete-account',
            name: 'direct-delete-account',
            component: DirectDeleteAccount,
            beforeEnter: needUserBefore
        },
        // PARTNERS
        {
            path: '/partner/:name',
            name: 'partner',
            component: Partner
        },
        {
            path: '/save-the-planet',
            name: 'save-the-planet',
            component: SaveThePlanet
        },
        {
            path: '/save-the-planet.html',
            redirect: '/save-the-planet'
        },

        // deeplinks
        {
            path: '/addInbox-link',
            redirect: '/add-inbox'
        },
        {
            path: '/stats-link',
            redirect: '/stats'
        },
        {
            path: '/referral-link',
            redirect: '/weforest'
        },
        {
            path: '/card-link',
            redirect: '/newsletters'
        },
        {
            path: '/stories-link',
            redirect: () => ({
                path: '/stats',
                query: {forceStories: true}
            })
        },
        {
            path: '/reconnect-link',
            redirect: '/add-inbox'
        },
        {
            path: '/panel-link',
            redirect: '/settings/panel'
        },
        {
            path: '/notif-link',
            redirect: '/settings/notifications'
        },
        // webflow
        {
            path: '/about',
            beforeEnter: staticPagesRedirect
        },
        {
            path: '/cookies-policy',
            beforeEnter: staticPagesRedirect
        },
        {
            path: '/faq',
            beforeEnter: staticPagesRedirect
        },
        {
            path: '/how-it-works',
            beforeEnter: staticPagesRedirect
        },
        {
            path: '/impressum',
            beforeEnter: staticPagesRedirect
        },
        {
            path: '/my-data',
            beforeEnter: staticPagesRedirect
        },
        {
            path: '/press',
            beforeEnter: staticPagesRedirect
        },
        {
            path: '/privacy',
            beforeEnter: staticPagesRedirect
        },
        {
            path: '/terms',
            beforeEnter: staticPagesRedirect
        },

        // others
        {
            path: '/*',
            redirect: '/'
        }
    ]
})

export default router

function loginRules(to, from, next) {
    const provider = to.path.split('/')[2]
    // check if redirection to consent page
    const email = SessionStorage.getItem('email')
    const acceptConsent = SessionStorage.getItem('acceptConsent')
    const invalidGrant = to.query.invalidGrant === 'true'
    const emailIsLastConsent = !!email && !!acceptConsent && email === acceptConsent


    // check if consent is validated
    if(!Storage.getItem('token') && from.path !== '/consent-page' && !invalidGrant && !emailIsLastConsent) {
        next({path: '/consent-page', query: {provider: provider, toPath: to.path}})
    } else {
    // check if page match with provider

        const isSpecificProvider = Providers.isSpecificProvider(provider)

        if (to.path.startsWith(`/login/${provider}`) && isSpecificProvider) {
            next()
        } else if (to.path === `/login/${provider}` && !isSpecificProvider) {
            next({path: '/login'})
        } else if (to.path === '/login' && isSpecificProvider) {
            next({path: `/login/${provider}`, params: {provider: provider}})
        } else if (to.path !== '/login') {
            next({path: '/login'})
        } else {
            next()
        }
    }
}

function checkRights(to, from, next) {

    if (Storage.getItem('token')) {
        Store.dispatch('getUserAsync')
        if (Store.getters.anonymousUser && to.path !== '/user-form') {
            next({path: '/user-form'})
        }
        next()
    } else {
        Auth.disconnect()
    }
}

function staticPagesRedirect(to) {

    switch (to.path) {
        case '/privacy':
            Agreements.set.privacy()
            break
        case '/terms':
            Agreements.set.terms()
            break
    }

    window.open(`${window.location.origin}/${Storage.getItem('lang')}${to.path}.html`, '_blank', 'rel="noopener,noreferrer,nofollow"')

}

function LandingRules(to, from, next) {

    Storage.getItem('token') ? next({path: '/newsletters'}) : next()

}

function needUserBefore(to, from, next) {
    if (Storage.getItem('token')) {
        Store.dispatch('getUserSync')
            .finally(() => {
                next()
            })
    } else {
        next()
    }
}